export default __webpack_public_path__ + "static/media/cert3.a2f348d7.png";